import {atom} from "recoil";


export const refreshReplyState = atom<string>({
  key: 'refreshReplyState',
  default: "",
})

